import { Checkbox } from "@/components/ui/checkbox"
import { ScrollArea } from "@/components/ui/scroll-area"
import { Badge } from "@/components/ui/badge"
import { Tournament } from "@/graphql"

interface RelatedTournament {
  id: number
  name: string
  selected?: boolean
}

interface TournamentRelatedSelectorProps {
  currentTournamentId: number
  related: Tournament[]
  selectedTournaments: RelatedTournament[]
  onSelectionChange: (tournaments: RelatedTournament[]) => void
}

export const TournamentRelatedSelector = ({
  currentTournamentId,
  related,
  selectedTournaments,
  onSelectionChange,
}: TournamentRelatedSelectorProps) => {
  const isSelected = (tournamentId: number) => {
    return selectedTournaments.some((t) => t.id === tournamentId && t.selected)
  }

  const handleToggle = (tournament: { id: number; name: string; startDate: string }) => {
    if (isSelected(tournament.id)) {
      onSelectionChange(selectedTournaments.filter((t) => t.id !== tournament.id))
    } else {
      onSelectionChange([
        ...selectedTournaments,
        { id: tournament.id, name: tournament.name, selected: true },
      ])
    }
  }

  const formatDate = (dateString?: string) => {
    if (!dateString) return ""
    return new Date(dateString).toLocaleDateString("es-ES", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
  }

  return (
    <div className="space-y-4">
      {/* Tournament List */}
      <ScrollArea className="h-[200px] border rounded-md bg-white dark:bg-gray-800">
        {related.length === 0 ? (
          <div className="flex items-center justify-center h-full text-muted-foreground text-sm">
            No se encontraron torneos
          </div>
        ) : (
          <div className="p-2 space-y-1">
            {related.map((tournament) => (
              <label
                key={tournament.id}
                className={`flex items-center gap-3 p-2 rounded-md cursor-pointer transition-colors ${
                  isSelected(tournament.id)
                    ? "bg-primary/10 dark:bg-primary/20 border border-primary/30"
                    : "hover:bg-gray-100 dark:hover:bg-gray-700"
                }`}
              >
                <Checkbox
                  checked={isSelected(tournament.id)}
                  onCheckedChange={() => handleToggle(tournament)}
                  className="border-gray-400 dark:border-gray-500"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium truncate">{tournament.name}</span>
                    {isSelected(tournament.id) && (
                      <Badge variant="secondary" className="text-xs">
                        Seleccionado
                      </Badge>
                    )}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {formatDate(tournament.startDate)}
                    {tournament.TournamentType && ` • ${tournament.TournamentType.name}`}
                  </div>
                </div>
              </label>
            ))}
          </div>
        )}
      </ScrollArea>
    </div>
  )
}
